import React from "react";
import { Navigate, useParams } from "react-router-dom";

const normalizeSegment = (value) => {
  if (!value) return "";
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .trim()
    .replace(/\s+/g, "");
};

const moduleMap = {
  Beneficios: "Separaciones",
  ServiciosSociales: "Sociales",
  UnidaddeOperaciones: "Operaciones",
  UnidaddeServiciosLegales: "Legal",
  PortaldelParticipante: "PortalDelParticipante",
};

const resolveModuleSegment = (rawModule) => {
  const normalized = normalizeSegment(rawModule);
  return moduleMap[normalized] || normalized;
};

export default function RouteResolver() {
  const { modulo, menu, submenu, opcion } = useParams();
  const moduleSegment = resolveModuleSegment(modulo);
  const leaf = opcion || submenu || menu;
  const leafSegment = normalizeSegment(leaf);

  if (!moduleSegment || !leafSegment) {
    return <Navigate to="/Inicio" replace />;
  }

  return <Navigate to={`/${moduleSegment}/${leafSegment}`} replace />;
}
